export default __webpack_public_path__ + "static/media/child-account-white.52b2bc04.svg";